// gatsby-browser.js
require('prismjs/themes/prism-okaidia.css')
require('normalize.css')
require('./src/styles/global.sass')
